// Third Party
import * as React from 'react';

// UI
import { SearchMap } from './search-map/search-map';
import { MapProvider } from '@components/map/map-context';

type Props = {};

export const Search: React.FC<Props> = () => {
  return (
    <MapProvider>
      <SearchMap />
    </MapProvider>
  );
};
